import React, { useRef, useState, useLayoutEffect } from 'react';

import './dopi.css';
import { isMobile } from 'react-device-detect';


const Infopr=()=>{

useLayoutEffect(()=>{
	const ddongpa = document.getElementById("dolly");
  //  ddongpa.scrollIntoView({behavior:"smooth", block: "start", inline: "nearest"});    
	window.scrollTo(0,0);
},[]);

	document.title = "개인정보 이용방침 - 돌파공모";
return(
<div className='dollz' id='dolly'>
<h3>개인정보 수집 및 이용 방침</h3>
		<p>돌파공모(‘www.dolpagongmo.com’)은 고객님의 개인정보를 중요시하며, 정보통신망 이용촉진 및 정보보호 등에 관한 법률,
		개인정보 보호법을 비롯한 개인정보 관련 법령을 준수하고 있습니다. 회사는 개인정보를 보호하고 어떠한 용도와 방식으로 이용되고 있는지를
		다음과 같이 개인정보 처리방침을 수립·공개합니다.</p>
<br/>

		<p>수집하는 개인정보 항목</p>
		<p>회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집합니다.</p>
		<p>수집항목 : 이름, 로그인ID, 비밀번호, 휴대전화번호, 이메일, 사업자등록번호, 서비스 이용기록, 접속 로그, 접속 IP 정보, sms수신여부, Email수신여부
		개인정보 수집방법 : 홈페이지(회원가입)</p>
<br/>
		<p><strong>■ 개인정보의 수집 및 이용목적</strong></p>
					<p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>	
				<p>1.회원관리</p>			
					<p>회원제 서비스 이용에 따른 본인확인 , 개인 식별 , 불량회원의 부정 이용 방지와 비인가 사용 방지 , 가입 의사 확인 , 불만처리 등 민원처리 , 고지사항 전달</p>					
<br/>

		<p><strong>■ 개인정보의 보유 및 이용기간</strong></p>				
			<p>1.홈페이지 회원가입 후 탈퇴시 까지</p>
							
<br/>
			<p><strong>■ 개인정보의 파기절차 및 방법</strong></p>
				<p>회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.</p>	
				<p><span>1.파기절차</span> : 회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다.
					별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.</p>
				<p><span>2.파기방법</span> : 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</p>
<br/>
			<p><strong>■ 개인정보 제공</strong></p>
				<p>회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
				<p>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</p>			
<br/>
			<p><strong>■ 이용자 및 법정대리인의 권리와 그 행사방법</strong></p>
				<p>이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수 있습니다.
				이용자 혹은 만 14세 미만 아동의 개인정보 조회/수정을 위해서는 회원정보수정을 요청하고, 가입해지는 회원탈퇴를 요청합니다.
				오기재 개인정보를 제3자에게 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 하겠습니다.
				회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 “회사가 수집하는 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</p>
<br/>
			<p><strong>■ 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</strong></p>
				<p>회사는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’를 사용합니다. 사용 목적은 다음과 같습니다.</p>
					
				<p>1.쿠키 사용 목적</p>			
				<p>이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</p>
					
				<p>2.쿠키의 설치·운영 및 거부 </p>	
				<p>쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</p>

				<p>3.설정방법</p>
				<p>	- Internet Explorer : 웹 브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보 &gt; 설정</p>
				<p>	- Chrome : 웹 브라우저 우측의 설정 &gt; 고급 설정 표시 &gt; 개인정보의 콘텐츠 설정 버튼 &gt; 쿠키</p>
<br />

			<p><strong>■ 개인정보 보호책임자 및 권익침해 구제방법</strong></p>
			 <p>개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.</p>
				<p>개인정보관리책임자</p>
					<p>성명 : 정승재</p>
					<p>	연락처 : 010-8634-0876</p>
					<p>이메일 : dolpa@dolpagongmo.com</p>
			<p>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
				1.개인분쟁조정위원회 (www.1336.or.kr/1336)
				2.정보보호마크인증위원회 (www.eprivacy.or.kr/02-580-0533~4)
				3.대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr/02-3480-3600)
				4.경찰청 사이버테러대응센터 (www.ctrc.go.kr/02-392-0330)
			</p>
</div>
);

};

export default Infopr;